import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import { Form, Dropdown } from "semantic-ui-react";
// eslint-disable-next-line import/no-unresolved
import { provinces, states } from "common/helpers/config";

const memoizedProvinceOptions = [];
const memoizedStateOptions = [];

const provinceOptions = () => {
  if (!memoizedProvinceOptions.length) {
    provinces().forEach((elem) =>
      memoizedProvinceOptions.push({
        text: elem[0],
        value: elem[0],
      })
    );
  }

  return memoizedProvinceOptions;
};

const stateOptions = () => {
  if (!memoizedStateOptions.length) {
    states().forEach((elem) =>
      memoizedStateOptions.push({
        text: elem[0],
        value: elem[0],
      })
    );
  }

  return memoizedStateOptions;
};

const NonICAddressForm = ({
  currentFieldValue,
  updateField,
  invalidFieldValue,
  canValidateField,
  disabled,
}) => {
  const isCanadian = ["Canada", "CA"].includes(currentFieldValue("country"));
  const localRegions = isCanadian ? provinceOptions() : stateOptions();
  const regionPlaceholder = isCanadian ? "Province" : "State";

  const zipPlaceholder = isCanadian ? "Postal code" : "Zip code";
  const zipMask = isCanadian ? "******" : "99999";
  const zipPattern = isCanadian ? "[a-zA-Z0-9]*" : "\\d*";

  return (
    <>
      <Form.Group>
        <Form.Field
          width={7}
          error={invalidFieldValue && invalidFieldValue("street")}
          onBlur={() => canValidateField("street")}
          disabled={disabled}
        >
          <label htmlFor="new-user-street-address">Address</label>
          <input
            id="new-user-street-address"
            name="street"
            value={currentFieldValue("street")}
            onChange={(e) => updateField("street", e.target.value)}
            placeholder="Street"
          />
        </Form.Field>
        <Form.Field
          width={3}
          error={invalidFieldValue && invalidFieldValue("street2")}
          onBlur={() => canValidateField("street2")}
          disabled={disabled}
        >
          <label htmlFor="new-user-street-address-2">&nbsp;</label>
          <input
            id="new-user-street-address-2"
            name="street2"
            value={currentFieldValue("street2")}
            onChange={(e) => updateField("street2", e.target.value)}
            placeholder="Apt #"
          />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Input
          width={5}
          name="city"
          value={currentFieldValue("city")}
          onChange={(e, { value }) => updateField("city", value)}
          placeholder="City"
          disabled={disabled}
        />
        <Form.Field
          disabled={disabled}
          width={3}
          control={Dropdown}
          selection
          fluid
          options={localRegions}
          placeholder={regionPlaceholder}
          value={currentFieldValue("state")}
          onChange={(e, { value }) => updateField("state", value)}
        />
        <Form.Field
          width={3}
          error={invalidFieldValue && invalidFieldValue("zip")}
          onBlur={() => canValidateField("zip")}
          disabled={disabled}
        >
          <InputMask
            maskChar={null}
            placeholder={zipPlaceholder}
            mask={zipMask}
            pattern={zipPattern}
            value={currentFieldValue("zip")}
            onChange={(e) => updateField("zip", e.target.value)}
          />
        </Form.Field>
      </Form.Group>
    </>
  );
};

NonICAddressForm.propTypes = {
  disabled: PropTypes.bool.isRequired,
  currentFieldValue: PropTypes.func.isRequired,
  updateField: PropTypes.func.isRequired,
  invalidFieldValue: PropTypes.func.isRequired,
  canValidateField: PropTypes.func.isRequired,
};

export default NonICAddressForm;
